<template>
  <div class="modal fade" id="NormalModal" tabindex="-1" style="z-index:2041;" aria-labelledby="NormalModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-middle">
          <div v-html="this.$props.Content"></div>
        </div>
        <div class="modal-footer">
          <div class="Left"></div>
          <div class="Right">
            <button class="btn btn-dark" data-bs-dismiss="modal">關閉</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    Content: String,
  },
}
</script>

<style lang="scss" scoped>
.modal {
  > .modal-dialog {
    > .modal-content {
      > .modal-middle {
        padding: 20px;
        font-weight: bold;
      }
      > .modal-footer {
        display: block;
        > .Left {
          float: left;
          > button {
            font-weight: bold;
          }
        }
        > .Right {
          float: right;
          > button {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>